export enum PaymentIntentStatus {
  SUCCEEDED = "succeeded",
  CANCELED = "canceled",
  REQUIRES_PAYMENT_METHOD = "requires_payment_method",
  REQUIRES_CONFIRMATION = "requires_confirmation",
  REQUIRES_CAPTURE = "requires_capture",
  FULL_REFUND = "fullRefund",
  PARTIAL_REFUND = "partialRefund",
  DISPUTED = "disputed",
  FAILED = "failed",
}
